import { useMemo } from 'react';
import Head from 'next/head';

import { Link, Svg } from '../snippets';

export default function ArticleTemplate({ article, renderSections }) {
  const publishedAt =
    article.firstPublishedAt || article.publishedAt || article.createdAt;
  const date = useMemo(() => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Date(publishedAt).toLocaleDateString('en-US', options);
  }, [publishedAt]);

  const heading = article?.title;

  return (
    <>
      {heading && (
        <Head>
          <title>
            {heading && process.env.NEXT_PUBLIC_SITE_TITLE
              ? `${heading} | ${process.env.NEXT_PUBLIC_SITE_TITLE}`
              : heading || process.env.NEXT_PUBLIC_SITE_TITLE || 'Rhoback'}
          </title>
        </Head>
      )}

      <div className="flex py-1 md:py-2.5 md:-mb-5 xl:-mb-10 px-contained">
        <div className="text-sm md:text-base max-w-[var(--content-max-lg-width)] mx-auto w-full">
          <Link
            aria-label="Journal"
            className="flex flex-row items-center gap-2.5 text-sm text-mediumGray" 
            href="/blogs/journal"
            type="link"
          >
            <Svg
              className="w-3 text-mediumGray"
              src="/svgs/chevron-left.svg#chevron-left"
              alt="Left Chevron Icon"
              title="Chevron"
              viewBox="0 0 24 24"
            />
            Journal
          </Link>
        </div>
      </div>

      <div className="py-contained mx-md:!pt-0">
        <div className="px-contained mb-8 flex flex-col items-center gap-3 text-center md:mb-10">
          <p className="text-sm md:text-base">
            {article.author ? `${article.author} | ` : ''}
            {date}
          </p>

          <h1 className="text-title-h2 max-w-[60rem]">{heading}</h1>

          {article.category && (
            <p className="btn-text flex h-8 items-center justify-center rounded-full bg-lightGray px-4 text-text">
              {article.category}
            </p>
          )}
        </div>

        {renderSections()}
      </div>
    </>
  );
}

ArticleTemplate.displayName = 'ArticleTemplate';
